import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import LandingPage from "@/pages/LandingPage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import ResultsPage from "@/pages/ResultsPage";
import SharedResultPage from "@/pages/SharedResultPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  // Capture UTM/attribution params on first load — first touch wins
  if (!sessionStorage.getItem("g4l_attribution")) {
    const params = new URLSearchParams(window.location.search);
    const data = {};
    for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"]) {
      const val = params.get(key);
      if (val) data[key] = val;
    }
    if (Object.keys(data).length > 0) {
      sessionStorage.setItem("g4l_attribution", JSON.stringify(data));
    }
  }

  return (
    <TooltipProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/questionnaire" element={<QuestionnairePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/results/:sessionId" element={<SharedResultPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;
